interface SourceLineProps {
  source: string;
  sourceUrl?: string;
  retrievedOn: string;
}

function formatDate(iso: string) {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function SourceLine({ source, sourceUrl, retrievedOn }: SourceLineProps) {
  return (
    <p className="text-[12px] leading-relaxed text-muted-foreground">
      Source:{" "}
      {sourceUrl ? (
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-liberty-gold underline underline-offset-2 hover:opacity-80"
        >
          {source}
        </a>
      ) : (
        source
      )}{" "}
      · retrieved {formatDate(retrievedOn)}
    </p>
  );
}
